
const digest = '7b6f2f0c4febfa0f7ef825757c62c0e90d481cfa10420274225a7d4b385b630a';
const classes = {"wrapper":"_wrapper_wfac8_1","item":"_item_wfac8_5","title":"_title_wfac8_11"};
const css = `._wrapper_wfac8_1 {
  display: flex;
  flex-direction: column;
}
._wrapper_wfac8_1 ._item_wfac8_5 {
  font-family: Rubik, sans-serif;
  border: 1px solid #d1d4da;
  border-radius: 3px;
  margin-bottom: 10px;
}
._wrapper_wfac8_1 ._item_wfac8_5 ._title_wfac8_11 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 24px;
  color: #1665d8;
  font-size: 16px;
  font-weight: 500;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  